const config = {
    "environment": process.env.REACT_APP_ENVIRONMENT,
    "tenantId": process.env.REACT_APP_AUTH_TENANT_ID,
    "api": {
        "rootPath": process.env.REACT_APP_WEB_API_BASE_URL,
        "scopes": [process.env.REACT_APP_WEB_API_APPLICATION_ID_URI]
    },
    "configurations": {
        "subjectLimit": parseInt(process.env.REACT_APP_SUBJECT_LIMIT) ? parseInt(process.env.REACT_APP_SUBJECT_LIMIT) : 3
    }
}

export default config;